export default __webpack_public_path__ + "static/media/Kirai set.07f6c894.JPG";